import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ComparisonSection, { CTASection } from './components/ComparisonSection';
import ArticleCards from './components/ArticleCards';
import FAQSection from './components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.autos';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <AboutSection />
        <ComparisonSection />
        <ArticleCards />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Superbuy Spread',
            url: siteUrl,
            description:
              'The ultimate Superbuy Spreadsheet resource hub for finding trending products, organized categories, verified information and smarter shopping guides.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is Superbuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'The Superbuy Spreadsheet is a community-curated database of product links from Chinese marketplaces like Taobao and Weidian. It organizes thousands of finds into easy-to-browse categories, complete with QC photos, sizing information, and price references.',
                },
              },
              {
                '@type': 'Question',
                name: 'Is Superbuy Spreadsheet safe?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Yes, the Superbuy Spreadsheet is safe when used properly. The spreadsheet itself is just a collection of product links — it does not handle payments or store personal data.',
                },
              },
              {
                '@type': 'Question',
                name: 'How often is it updated?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'The Superbuy Spreadsheet is updated on a regular basis with new product finds, removed dead links, and refreshed categories. Major updates typically roll out every few weeks.',
                },
              },
              {
                '@type': 'Question',
                name: 'How do I use Superbuy Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Browse through the organized categories to find products, click on product links to view item details, check QC photos and reviews, then use your preferred shopping agent to purchase.',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}